(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    if (!window.themeScrollReveal) {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const observer = prefersReducedMotion
      ? null
      : new IntersectionObserver(
          (entries, obs) => {
            for (const entry of entries) {
              if (entry.isIntersecting) {
                entry.target.classList.add('scroll-reveal--visible');
                obs.unobserve(entry.target);
              }
            }
          },
          { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
        );

    const observeAll = () => {
      if (!observer) return;
      document.querySelectorAll('.scroll-reveal:not(.scroll-reveal--visible)').forEach((el) => {
        observer.observe(el);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAll);
    } else {
      observeAll();
    }

    document.addEventListener('shopify:section:load', observeAll);

    window.themeScrollReveal = { observer, observeAll };
  }
  } catch(e) { console.error(e); }
})();

})();
